import { Alert, Button } from '@mui/material'
import { useHistory, Link } from 'react-router-dom'
import { useGetData } from '../context/getDataContext'

const ExpirationAlert = () => {
  const history = useHistory()
  const { expiredDocuments, expiredDocumentsLoading, expiredDocumentsError } =
    useGetData()

  if (
    expiredDocumentsLoading ||
    expiredDocumentsError ||
    expiredDocuments.length === 0
  ) {
    return null
  }

  const total = expiredDocuments.length
  const message =
    total === 1 ? 'Há 1 documento vencido.' : `Há ${total} documentos vencidos.`

  return (
    <Alert
      className="!text-xs !md:text-base mb-2"
      color="error"
      action={
        <a
          href="/documentos-vencidos"
          className="cursor-pointer font-bold underline opacity-80 hover:opacity-100 transition-colors"
        >
          Ver detalhes
        </a>
      }
    >
      {message}
    </Alert>
  )
}

export default ExpirationAlert
